<div class="p-4">
  @if (error) {
    <app-alert type="danger">{{ error }}</app-alert>
  }

  @if (initialLoading) {
    <app-loading size="large" />
  }

  @if (!initialLoading && parsed) {
    <div class="flex items-center gap-4 mb-4 flex-wrap">
      <span class="text-sm font-semibold text-neutral-500 dark:text-neutral-400">
        Canal de venda:
      </span>
      @for (channel of channels; track channel.id) {
        <label class="flex items-center gap-1.5 cursor-pointer text-sm text-black dark:text-white">
          <input
            type="radio"
            name="channel"
            [value]="channel.id"
            [checked]="selectedChannelId === channel.id"
            (change)="selectedChannelId = channel.id; onFilterChange()"
            [disabled]="refreshing"
            class="accent-blue-600" />
          {{ channel.label }}
        </label>
      }

      <span class="h-5 w-px bg-neutral-300 dark:bg-neutral-600 mx-2"></span>

      <span class="text-sm font-semibold text-neutral-500 dark:text-neutral-400">
        Tipo de seller:
      </span>
      @for (type of sellerTypes; track type.id) {
        <label class="flex items-center gap-1.5 cursor-pointer text-sm text-black dark:text-white">
          <input
            type="radio"
            name="sellerType"
            [value]="type.id"
            [checked]="selectedSellerType === type.id"
            (change)="selectedSellerType = type.id; onFilterChange()"
            [disabled]="refreshing"
            class="accent-blue-600" />
          {{ type.label }}
        </label>
      }
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      <div class="revenue-card-wrapper">
        <app-value-card
          title="Faturamento hoje"
          subtitle="Total acumulado hoje de 00:00 até {{ currentHourBR() }}"
          [value]="refreshing ? '' : formatBRLFromCents(parsed.today.value)"
          icon="dollar-sign"
          color="success" />
        @if (refreshing) {
          <div class="skeleton-overlay"><div class="skeleton-bar"></div></div>
        }
      </div>

      <div class="revenue-card-wrapper">
        <app-value-card
          title="Faturamento ontem"
          subtitle="Total acumulado ontem de 00:00 até {{ currentHourBR() }}"
          [value]="refreshing ? '' : formatBRLFromCents(parsed.yesterdaySameHour.value)"
          icon="dollar-sign"
          color="info" />
        @if (refreshing) {
          <div class="skeleton-overlay"><div class="skeleton-bar"></div></div>
        }
      </div>

      <div class="revenue-card-wrapper">
        <app-value-card
          title="Faturamento semana anterior"
          subtitle="Total acumulado na semana anterior de 00:00 até {{ currentHourBR() }}"
          [value]="refreshing ? '' : formatBRLFromCents(parsed.lastWeekFullDay.value)"
          icon="dollar-sign"
          color="primary" />
        @if (refreshing) {
          <div class="skeleton-overlay"><div class="skeleton-bar"></div></div>
        }
      </div>
    </div>
  }
</div>
